import React from "react";
import { FaAddressBook, FaPlus, FaRegArrowAltCircleLeft, FaSync, FaTrash } from "react-icons/fa";
import { HiDocumentText } from "react-icons/hi2";
import { useLocation, useNavigate } from "react-router-dom";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import { SettingGeneralProvider } from "../../../context/settingGeneralContext";
import HeaderReusable from "../../Global/HeaderContent";

export default function HeaderSatuSehat({
  isTabletOrMobile,
  title = "Satu Sehat",
  query,
  setQuery,
  limit,
  setLimit,
  searchData,
  buttonRefresh,
  viewModalAdd,
  handleModalRelationPatient,
  showCustomButtonRelationPatient
}) {
  return (
    <SettingGeneralProvider>
      <HeaderAdminSatuSehatContent
        isTabletOrMobile={isTabletOrMobile}
        title={title}
        query={query}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        viewModalAdd={viewModalAdd}
        buttonRefresh={buttonRefresh}
        searchData={searchData}
        handleModalRelationPatient={handleModalRelationPatient}
        showCustomButtonRelationPatient={showCustomButtonRelationPatient}
      />
    </SettingGeneralProvider>
  )
}

function HeaderAdminSatuSehatContent({
  isTabletOrMobile,
  title,
  query,
  setQuery,
  limit,
  setLimit,
  searchData,
  buttonRefresh,
  viewModalAdd,
  handleModalRelationPatient,
  showCustomButtonRelationPatient
}) {
  return (
    <>
      <HeaderReusable
        title={title}
        icon={HiDocumentText}
        isTabletOrMobile={false}
        query={query}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        searchData={false}
        onAdd={viewModalAdd}
        showEntriesButton={false}
        showAddButton={false}
        onRefresh={buttonRefresh}
        showRefreshButton={true}
        handleModalRelationPatient={handleModalRelationPatient}
        showCustomButtonRelationPatient={showCustomButtonRelationPatient}
      />
    </>
  )
}
